<template>
  <div>
    <!--直播间列表对话框-->
    <el-dialog
      title=""
      :visible.sync="showParticipantsDialogFormVisible"
      width="1200px"
      top="25vh"
      class="dislogCon-Participants"
      style="margin: 0 auto;text-align:center;z-index: 2000;"
    >
      <!-- :aloneData="participants" -->
      <div
        class="dialog-top"
        style="border-radius:5px;clear:both;overflow:hidden; margin-bottom: 20px;"
      >
        <div style="text-align: center">
          <div
            class="company-top-logo"
          >
            <img
              v-if="broadCastList.company_logo_url"
              :src="broadCastList.company_logo_url"
              alt=""
              style="max-width: 100%;max-height: 100%;object-fit: cover;top: 50%;left: 50%;position: relative;transform: translate(-50%, -50%)"
            />
            <img
              v-else
              src="../../assets/img_default_avatar.png"
              alt=""
              style="width: 100%;height: 100%;border-radius: 50%;"
            />
          </div>
          <div style="position: absolute;right: 80px;top:130px;">
            <template v-if="lan == 'ch'">
              <div style="display: inline-block;margin-right:20px;">
                <el-button
                  style="dislogCon-Participants-btn"
                  type="primary"
                  @click="
                    showImg({
                      currentTab: 1,
                      exhibition_id: broadCastList.finally_in_exhibtion,
                      broadcast_id: broadCastList.user_id,
                    })
                  "
                  v-if="lan == 'ch'"
                  >手机海报分享</el-button
                >
                <el-button
                  style="dislogCon-Participants-btn"
                  type="primary"
                  @click="
                    showImg({
                      currentTab: 1,
                      exhibition_id: broadCastList.finally_in_exhibtion,
                      broadcast_id: broadCastList.user_id,
                    })
                  "
                  v-if="lan == 'en'"
                  >Share Link</el-button
                >
              </div>
            </template>

            <el-button
              style="dislogCon-Participants-btn"
              type="primary"
              @click="
                showPcUrl({
                  exhibition_id: broadCastList.finally_in_exhibtion,
                  broadcast_id: broadCastList.user_id,
                })
              "
              v-if="lan == 'ch'"
              >主页链接分享</el-button
            >
            <el-button
              style="dislogCon-Participants-btn"
              type="primary"
              @click="
                showPcUrl({
                  exhibition_id: broadCastList.finally_in_exhibtion,
                  broadcast_id: broadCastList.user_id,
                })
              "
              v-if="lan == 'en'"
              >Booth Link</el-button
            >
          </div>
        </div>
        <div v-if="lan == 'ch'">
          <div
            class="broadCastList-company"
            style=" font-size: 20px;margin-top:60px;"
          >
            {{ broadCastList.company }}
          </div>
          <!-- <div style="padding-top:20px;">{{broadCastList.location}}</div> -->
          <!-- <span style="margin-left: 30px;">{{broadCastList.user_post}}:{{broadCastList.true_name}}</span> -->
          <div
            style="width:98%;margin:30px auto 0;line-height: 22px; text-align: left;padding:20px 10px 20px;
                    background-color: rgb(255,255,255,0.2);color: #FFFFFF;text-indent: 2em;border-radius: 5px;letter-spacing: 1px;"
          >
            {{ broadCastList.company_desc }}

          </div>
        </div>
        <div v-if="lan == 'en'">
          <div
            class="broadCastList-company"
            style="font-size: 24px;margin-top:60px;"
          >
            {{ broadCastList.company_en }}
          </div>
          <!-- <div style="padding-top:20px;">{{broadCastList.location_en}}</div> -->
          <!-- <span style="margin-left: 30px;">{{broadCastList.user_post_en}}:{{broadCastList.true_name_en}}</span> -->
          <div
            style="width:80%;margin:0 auto;color:#fff;line-height: 22px; text-align: justify;padding-top:20px;"
          >
            {{ broadCastList.company_desc_en }}
          </div>
        </div>
      </div>
      <!--          直播间三个文字-->
<!--      <img-->
<!--        src="@/assets/zhibojianwenzi.png"-->
<!--        alt=""-->
<!--        style="height: 30px; margin-top: 20px; margin-bottom: 30px;"-->
<!--        v-if="lan == 'ch'"-->
<!--      />-->
<!--      <img-->
<!--        src="@/assets/zhibojianwenzi_en.png"-->
<!--        alt=""-->
<!--        style="height: 30px; margin-top: 20px; margin-bottom: 30px;"-->
<!--        v-else-->
<!--      />-->
      <!--招聘岗位-->
      <div style="text-align: center;height: 80px;">
<!--        <div style="color: #0c78fe;font-size: 30px;font-weight: bold;z-index: 2;margin-top: 40px;">—— 招聘岗位 ——</div>-->
<!--        <div style="color: #0c78fe;font-size: 32px;font-weight: bold;opacity: 0.2;position: relative;top: -60px;letter-spacing: 1px">-->
<!--          EXHIBIHON AREA</div>-->
        <img src="../../assets/img/jobt.png" style="width: 121px;margin-top: 8px;">
      </div>

      <!--岗位信息-->
<!--            <div v-if="(zpPost != null && zpPost != '')"-->
<!--                  style="font-size: 20px;border: none;background-color: #FFFFFF;padding: 20px 25px 0 25px;width: 1050px;">-->
<!--              <div style="float: left; font-size: 22px;font-weight: bold;-->
<!--                          color: #282828;">-->
<!--                  岗位名字</div>-->
<!--              <div style="float: right;color: #282828;font-weight: bolder;font-size: 18px;">-->
<!--                <span>工作所在地：大连</span>-->
<!--                <span style="padding-left: 40px;color: #237dfe;font-size: 16px;">岗位薪资：3k-5k</span></div>-->
<!--              <div style="clear: both; text-align: left;text-indent: 2em;padding: 10px 0 2px 0;margin-left: 0;">-->
<!--                岗位信息要求</div>-->
<!--              </div>-->
      <!--展商下的直播间-->
      <template v-for="(item, index) in broadCastList.broadCast">
        <one-to-one
          ref="ontoone"
          :key="index"
          :k="index"
          :nowJobId="nowJobId"
          v-loading="loading"
          :language="language"
          :zpPost="zpPost"
          style="margin-bottom: 40px;background-color: #FFFFFF;border: none;"
          :exhState="intro.exh_type"
          :aloneData="item"
          :lan="lan"
          :emailHidden="emailHidden"
          :userNature="userInfo.user_nature"
          :hiddenshow="showParticipantsDialogFormVisible"
          @getLiveInfo="tips"
          @newHandleInfo="newHandleInfo"
          @showImg="showImg"
          @showPcUrl="showPcUrl"
          @newToggelSubject="newToggelSubject"
        />
<!--        @getLiveInfo="handleLive"-->
      </template>
      <pagination
        v-if="broadCastTotal > 3"
        class="pagination"
        :total="broadCastTotal"
        jumpColor="white"
        :limit.sync="broadCastTotalNumberPage"
        :page.sync="broadCastTotalPage"
        @pagination="broadCastTotalHandleExhList"
      />
    </el-dialog>

    <!--固定报名连接--end-->

    <!-- 邀请码分享 -->
    <el-dialog
      title=""
      :visible.sync="showImgDialogFormVisible"
      width="1200px"
      top="10vh"
      class="dislogCon-Img"
      style="margin: 0 auto;text-align:center;"
    >
      <!-- <img :src="imgSrc" alt="" style="margin: 0 auto;text-align:center;"> -->
      <div class="img-wrap">
        <div class="img-wrap-left">
          <img class="choose-img" :src="imgSrcList[imgSrcIndex]" alt="" />
        </div>
        <div class="img-wrap-right">
          <div class="img-wrap-title">
            <p>制作手机海报分享</p>
            <div class="div-border-bottom-color"></div>
          </div>
          <div class="img-wrap-right-top">
            <div
              :class="
                imgSrcIndex == index
                  ? 'img-wrap-right-top-div img-wrap-right-top-div-active'
                  : 'img-wrap-right-top-div'
              "
              v-for="(item, index) in imgSrcList"
              :key="index"
            >
              <img :src="item" alt="" @click="changeImgSrc(index)" />
              <img
                v-if="imgSrcIndex == index"
                class="img-right"
                src="../../assets/icon-right.png"
                alt=""
              />
            </div>
          </div>
          <div class="img-formBtn">
            <el-button class="img-down-formBtn" @click.native="imgDown"
              >下载</el-button
            >
            <el-button
              class="img-camcale-formBtn"
              type="primary"
              @click.native="cancelImg"
              >取消</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- pc链接分享 -->
    <el-dialog
      :title="language.Sharelinks"
      :visible.sync="showPcUrlDialogFormVisible"
      width="1200px"
      top="30vh"
      class="dislogCon"
      style="margin: 0 auto;text-align:center;"
    >
      <div class="pc-url-div">
        <p id="copy_pc_url">{{ pcUrl }}</p>
      </div>
      <div class="url-formBtn">
        <el-button
          type="warning"
          class="pc-url-formBtn"
          @click.native="copyPcUrl"
          v-if="lan == 'ch'"
          >复制</el-button
        >
        <el-button
          type="warning"
          class="pc-url-formBtn"
          @click.native="copyPcUrl"
          v-else
          >Copy</el-button
        >
      </div>
      <!-- <img :src="imgSrc" alt="" style="margin: 0 auto;text-align:center;"> -->
      <!-- <div class="img-wrap">
                <div class="img-wrap-left">
                    <img class="choose-img" :src="imgSrcList[imgSrcIndex]" alt="">
                </div>
                <div class="img-wrap-right">
                    <div class="img-wrap-title">
                        <p>邀请码分享</p>
                        <div class="div-border-bottom-color"></div>
                    </div>
                    <div class="img-wrap-right-top">
                        <div :class="imgSrcIndex == index ? 'img-wrap-right-top-div img-wrap-right-top-div-active' : 'img-wrap-right-top-div' " v-for="(item, index) in imgSrcList" :key="index">
                            <img :src="item" alt="" @click="changeImgSrc(index)">
                            <img v-if="imgSrcIndex == index" class="img-right" src="../../assets/icon-right.png" alt="">
                        </div>
                    </div>
                    <div class="img-formBtn">
                        <el-button class="img-down-formBtn" @click.native="imgDown">下载</el-button>
                        <el-button class="img-camcale-formBtn" type="primary" @click.native="cancelImg">取消</el-button>
                    </div>
                </div>
            </div> -->
    </el-dialog>

    <receiveMsg></receiveMsg>

    <!--登录注册-->
    <hint-message
        :show.sync="showHint"
        :title="title"
        @confirm="getConfirm"
        :promptContent="promptContent"
        :type="type"
        :loginData="loginData"
    />

    <el-dialog
        :visible.sync="tipsPay"
        width="400px"
        top="40vh"
        style="text-align: center;color: #313030;">
        <div style="font-size: 16px;margin-bottom: 10px;font-weight: 600;letter-spacing: 2px;">如果需要招聘企业详细信息</div>
        <div style="font-size: 16px;margin-bottom: 10px;font-weight: 600;letter-spacing: 2px;">请报名<span style="color: #0071FF;">本次云聘</span></div>
        <div>
          <el-button style="background: #0071FF;color: #FFFFFF;padding: 10px 24px !important;margin-top: 20px;"
                      @click="payTiao">马上报名</el-button>
        </div>
    </el-dialog>

  </div>
</template>

<script>
import lineDialog from "../../components/LineDialog";
import dragDialog from "../../components/DragDialog/index";
import navExhibition from "../../components/NavExhibition/index";
import footerBlogroll from "../../components/FooterBlogroll/footerBlogroll";
import {getLanguage, language} from "../../language/get";
import {MessageBox} from 'element-ui';
import backTop from "../../components/BackTop/index";
import reqest from "@/common/reqest";
import {
  getBroadcastClass,
  pcShareLink,
  getChannelConnect,
  getCompanysList,
  getExhibitionUser,
  getExhibitionUserCount,
  getBroadcastSubList,
  cancelBroadcastSubscribe,
  getExhibitionChannel,
  getExhibitionInfo,
  getCompanysDetails,
  selectRecruitPost,
  getNoticeAll, getJobFairNum
} from "../../api/exhibition";
import {
  getNewLiveUrl,
  getExhticketUserCount,
  getCountryState,
} from "../../api/forum";
import {
  visitorsEnterLiveRoom,
  cancelReservation,
  exhTime,
  exhibitionIntroduc,
  getLiveRoom,
  getCompanys,
  broadcast,
  guest,
  getAllLiveRoom,
  getExhibitionChannelInfo,
} from "@/api/newRequest";
import oneToOne from "./oneToOne/index";
import newOneToOne from "./newOneToOne/index";
import {getLiveUrl} from "@/api/forum";

import forum from "./forum/index";
import detailsInformation from "./detailsInformation/index";

import guestsList from "./guestsList/index";
import { mapGetters } from "vuex";
import getParamter from "../../common/util";

import hintMessage from "../../components/HintMessage/index";
import {
  ExhibitionTypeEnum,
  ExhibitionHandleEnum,
  loginType,
} from "../../common/constant/exhibition";
import { stateEnum } from "./oneToOne/enum";
import { selectContact } from "../../api/forum";
import pagination from "../../components/Pagination/pagination";
import { getWebSocket, init } from "../../common/socket";
import countDownDialog from "../../components/CountdownDialog";
import Cookie from "../../common/cookie";
import { roomUrl, videoUrl, windowsGoTo } from "../../common/url";
import { tickUrl, ticketsRegisterUrl } from "../../common/url";
import { isInternet } from "../../common/validate";
import downloadDialog from "../../components/DownloadDialog/index";
import announcement from "../../components/announcement";

import axios from "axios";
import receiveMsg from "../../components/receiveMsg";
import marquee from "../../components/marquee/marquee";
import {getExhibitorsLogoList} from "@/api/forum";

const pubLanguage = language();
export default {
  components: {
    receiveMsg,
    navExhibition,
    downloadDialog,
    footerBlogroll,
    backTop,
    oneToOne,
    newOneToOne,

    forum,
    detailsInformation,

    guestsList,
    hintMessage,
    pagination,
    lineDialog,
    countDownDialog,
    dragDialog,
    announcement,
    marquee
  },
  props:{
    jobvalue:{
      type:Array
    }
  },

  data() {

    const that = this;
    let pageLan = getParamter.getQueryString("lan");
    if (pageLan == "ch") {
      Cookie.del("lang");
      Cookie.set("lang", "ch", 7);
    } else if (pageLan == "en"){
      Cookie.del("lang");
      Cookie.set("lang", "en", 7);
    }

    console.log('----------1---------------');
    return {
      exh_item:null,
      room_id:null,
      emailHidden:null,
      tipsPay:false, //购买权限
      areaVisible: false,
      areaName: '',
      areaEl: null,
      allNotice:"",
      broadcastNum: 0,
      nowJobId: 0,
      moren1:
        "https://yunzhan-1251180497.cos.ap-nanjing.myqcloud.com/bc59bdc4943a1afe6631ed5682ce58ef3ce54718.jpeg",
      abcSearchList: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "全部",
      ],
      abcSearchList_en: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "All",
      ],
      //招聘岗位的数量
      jobsNum:null,
      //企业性质
      firmQuality:[
        {
          value:'0',
          label:getLanguage().companyProperty1
        },{
          value:'1',
          label:getLanguage().companyProperty2
        },{
          value:'2',
          label:getLanguage().companyProperty3
        },{
          value:'3',
          label:getLanguage().companyProperty4
        },{
          value:'4',
          label:getLanguage().companyProperty5
        },{
          value:'5',
          label:getLanguage().companyProperty6
        }],
      exhibitorsTabId: 'oe',
      firstNum: -1,
      dataList: [],
      datacount: 0,
      a: true,
      c: true,
      d: true,
      b: true,
      carouselImage: [],
      dialogShow: false,
      watchTitle: "",
      initCont: {},
      loading: true,
      exhibitionId: null,
      loginType,
      lan: Cookie.get("lang"),
      language: language(),
      activeName: "1",
      liveClassNumber: null, //直播分类
      recruitClassNumber:[], //招聘岗位下拉列表的值
      zpPost:null,  // 招聘岗位的具体信息
      firmQualityNumber:null, //企业性质
      studio: null, //直播间名称
      companyName: null, //公司名称
      locationName: null, //招聘工作地
      liveClass: null,
      recruitList:[], //招聘岗位信息列表
      topLiveList: [], //置顶直播间
      liveList: [], //直播间
      visitorsdata: [], //观展人员
      participantsdata: [], //参展人员
      guestsListdata: [], //嘉宾名单
      intro: {'exh_header_pic':'1.png'}, //简介
      showHint: false,
      promptContent: "",
      type: null, //弹窗类型
      title: "",
      ExhibitionTypeEnum,
      ExhibitionHandleEnum,
      stateEnum,
      pageOne: 1,
      numberPageOne: 10,
      totalOne: 0,
      pageForm: 1,
      numberPageForm: 4,
      totalForm: 0,
      page: 1,
      numberPage: 6,
      total: 0,
      searchResult:false,
      //排队
      visibleLine: false,
      waitData: {},
      clientId: null, //socket通信
      jobValue:[],
      columns: [
        {
          title: pubLanguage.date,
          key: "time",
          width: "370",
        },
        {
          title: pubLanguage.operation,
          key: "action",
          // width: ''
        },
      ],
      socket: null,
      broadcastId: null,
      warnConten: {},
      warnVisible: false,
      downloadShow: false,
      //轮播图
      swiperOptions: {
        direction: "horizontal",
        speed: 2000,
        loop: true,
        freeMode: true,
        observer: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        slidesPerView: "auto",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      carouselType: null,
      loginData: {},
      forum_tabs_height: null,
      guestsCompanyName: "",
      guestsBusiness: "",
      guestsLocation: "",

      guests_datacount: 0,
      guests_showSouNum: 0,
      guests_is_show: false,

      showType: "0",
      showGuestsType: false,

      imgSrcList: [],
      imgSrcIndex: 0,
      showImgDialogFormVisible: false,

      orderby: "",
      video4: true,

      participants: {},
      showParticipantsDialogFormVisible: false,
      typeIndex: 0,

      showPcUrlDialogFormVisible: false,
      pcUrl: "",
      isShowDetails: false, //是否自动显示展商详情
      participantsBool: false,

      abcString: "",
      broadCastList: {},

      renqi_type: "",
      indexNum: 0,

      broadCastTotal: 0,
      broadCastTotalNumberPage: 3,
      broadCastTotalPage: 1,

      dialogUserId: "",
      dialogFinallyInExhibtion: "",

      showForumTabsTable: "0",
      showGuestsTabsTable: "0",
      forumTabsTableType: 0,
      guestsTabsTableType: 2,

      newSubjectList: [],
      newshowSubject: false,
      subindex: 0,

      liveFormList: [],
      bgList: [],
      showContentMore: true,
      moreExhibitionList: [],

      descriptionActiveName: "0",

      ChannelList: [],

      ChannelConnectId: "",
      ChannelConnect: {},

      showRightFastEntry: true,

      adInsideLinkImg: require('../../assets/luqiaoAd.jpg'),
      adInsideLinkImgen: require('../../assets/luqiaoAd.jpg'),

      adExhibitorsLogoList:[], //展商logo广告
      adTonglanADList:''
    };
  },

  mounted(){

  },
  methods: {
    //购买
    payTiao() {
      this.$emit("payTiao",{type:3})
    },
    //查看企业弹窗
    tips(state) {
      this.tipsPay = state.state;
      console.log("状态；==" , this.tipsPay);
    },
    postMes(value){
      this.jobValue = value;
    },
    areaVisibleEvent(visible){
      this.areaVisible = visible;
      this.locationName = this.areaName;
    },
    showArea(e){
      this.areaEl = e.target;
      this.areaVisible = true;
      console.log("6" ,this.areaEl);
    },
    //展商logo图片广告
  showADimglist(item, index){
    this.showUpParticipants([{
        user_id: item.user_id,
        ExhibitionId: item.ExhibitionId,
      }]);
  },

    toggelSubject(e) {
      //e false
      //预约对话框
      this.newshowSubject = e;
    },
    closeSubject(a) {
      //预约对话框 a[0] false a[1] == this.subindex
      this.newshowSubject = a[0];
      console.log(a);
      //把预约状态设置为 1
      this.broadCastList.broadCast[this.subindex].subscribe_type = 1;
      this.broadCastList.broadCast[this.subindex].subscribe_count++;
      console.log("$1", this.broadCastList);
    },

    fmt(fmt) {
      return fmt.length == 1 ? "0" + fmt : fmt;
    },

    newToggelSubject(e) {
      //获取预约时间
      let item = e.item;
      let exh_begtime = item.exh_begtime.split(' ')[0];
      let exh_endtime = item.exh_endtime.split(' ')[0];
      let exhBegtime = new Date(exh_begtime.replace(/-/,"/"));
      let subscribeStart = item.subscribe_start;
      let subscribeEnd = item.subscribe_end;
      let dateList = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth()+1;
      let day = nowDate.getDate();
      let strDate = year + '-' + month + '-' + day;
      let nowTime = new Date(strDate.replace(/-/,"/")).getTime();
      let forCount = 0;
      for (;;) {
        forCount++;
        if(forCount > 365){
          //大于365天就跳出
          break;
        }
        year = exhBegtime.getFullYear();
        month = exhBegtime.getMonth()+1;
        day = exhBegtime.getDate();
        if(month < 10){
          month = '0' + month;
        }
        if(day < 10){
          day = '0' + day;
        }
        strDate = year + '-' + month + '-' + day;
        if(exhBegtime.getTime() >= nowTime){
          dateList.push({
            Ds: strDate,
            CantSubject: null
          });
        }
        if(strDate == exh_endtime){
          break;
        }
        exhBegtime.setDate(parseInt(day)+1);
      }
      exhBegtime = new Date((item.exh_begtime+":00").replace(/-/,"/"));
      let exhEndtime = new Date((item.exh_endtime+":00").replace(/-/,"/"));
      var subject = [];
      getBroadcastSubList({broadcast_id: item.broadcast_id}).then((res) => {
        let subList = res.data;
        nowTime = new Date().getTime();
        for (let index in dateList) {
          let start = parseInt(
              new Date(dateList[index].Ds + " "+subscribeStart+":00").getTime() / 1000
            );
          let end = parseInt(new Date(dateList[index].Ds + " "+subscribeEnd+":00").getTime() / 1000);

          let ls = ((end - start) / 3600) * 2;
          if (ls == 1) {
            ls = 0;
          }
          subject[index] = { days: dateList[index].Ds, broadcast_id: e, time: [] };

          for (let i = 0; i < ls; i++) {
            let c = start + 1800 * (i + 1);
            let s = new Date((start + i * 1800) * 1000);
            let a1 = new Date(c * 1000);
            if(exhBegtime.getTime() > s.getTime() || s.getTime() > exhEndtime.getTime() ){
              continue;
            }
            let t =
              this.fmt(s.getHours().toString()) +
              ":" +
              this.fmt(s.getMinutes().toString()) +
              "-" +
              this.fmt(a1.getHours().toString()) +
              ":" +
              this.fmt(a1.getMinutes().toString());
            let info = { time: t, issub: false, start: (s.getTime()/1000), end: (a1.getTime()/1000)};

            for (let k = 0; k < subList.length; k++) {
              if(subList[k].use_time == dateList[index].Ds+ ' ' + t){
                info.issub = true;
                break;
              }
            }
            /*if (dateList[index].CantSubject)
              dateList[index].CantSubject.forEach((res) => {
                if (res == t) k.issub = true;
              });
          */
            if(s.getTime() > nowTime){
              subject[index].time.push(info);
            }

          }
        }
        console.log(subject)
        this.subindex = e.subindex;
        this.newSubjectList = subject;
        //预约框的显示/隐藏
        this.newshowSubject = true;
      })
    },

    //获取显示国内外展商
    getCountryStateApi() {
      let props = {
        exhibition_id: this.exhibitionId,
      };
      getCountryState(props).then((res) => {
        this.showForumTabsTable = res.data.country_state;
        this.showGuestsTabsTable = res.data.jiabin;
        if (this.showForumTabsTable == "0") {
          this.forumTabsTableType = "";
        }
        if (this.showGuestsTabsTable == "0") {
          this.guestsTabsTableType = "";
        }
        this.getCompanySelectList();
        this.getguestsList();
      });
    },

    // 切换国内，外展商
    changeForumTabsTable(type) {
      this.forumTabsTableType = type * 1;
      this.getCompanySelectList();
    },

    // 嘉宾名单切换
    changeGuestsTabsTable(type) {
      this.guestsTabsTableType = type;
      this.getguestsList();
    },
    changePeople(type) {
      if(this.intro.exh_status == 0||this.intro.exh_status == 1){
          this.$message.error({ message: this.language.exhibitionNotStarted, offset: 120 });
        return;
      }
      this.orderby = "";
      this.renqi_type = type;
      this.loading = true;
      this.numberPage = 10;
      this.abcString = "";
      this.getCompanySelectList();
    },
    changeOrderby(type) {
      this.orderby = type;
      this.renqi_type = "";
      // if(type == 'popularity'){
      //     this.typeIndex = 0;
      //     this.orderby = 'popularity';
      // }else{
      //     this.typeIndex++;
      //     if(this.typeIndex % 2 == 0){
      //         this.orderby = 'desc';
      //     }else{
      //         this.orderby = 'asc';
      //     }
      // }
      this.abcString = "";
      this.loading = true;
      this.numberPageOne = 10;
      this.getCompanySelectList();
    },
    isIE() {
      //ie?
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isIE =
        userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
      var isIE11 =
        userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;

      var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器

      if (isIE || isEdge || isIE11) {
        return true;
      } else {
        return false;
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // initBanner() {
    //     getBanner().then(res => {
    //         this.carouselType = res.type;
    //         this.carouselImage = res.data;
    //     })
    // },
    loadData(exhibition_id) {
      var that = this;

      //this.exhibitionId = getParamter.getQueryString("exhibition_id");
      this.exhibitionId = exhibition_id;
      console.log('--------loadData----------',this.exhibitionId);
      // if (!this.exhibitionId || this.exhibitionId == null) {
      //   return (window.location.href = "index.html");
      // }
      //var exhibition = localStorage.getItem("exhibition"+that.exhibitionId+that.lan);
      //if(!exhibition) {
      //获取展会介绍
      // selectList({
      //   exhibition_id: this.exhibitionId,
      //   currentPage: 1,
      //   numberPage: 6,
      //   lan:this.lan
      // })

    //展商logo广告
     /*getExhibitorsLogoList({exhibition_id: this.exhibitionId, platform_type:0,ad_id:9,ad_type:0}).then(
        (res) => {
            this.adExhibitorsLogoList = res.data || [];
        }
      ),

      getExhibitorsLogoList({exhibition_id: this.exhibitionId, platform_type:(this.lan == "ch"?0:1),ad_id:8,ad_type:0}).then(
        (res) => {
          this.adTonglanADList = res.data[0].file_path || [];
        }
      ),*/
      //展会简介
      getExhibitionInfo({exhibition_id: this.exhibitionId}).then(
        (res) => {
          if (res.type != 1) {
            if (this.lan == "ch") {
              return this.$message.error({
                message: res.text,
                offset: 120,
              });
            }
            return this.$message.error({
              message: res.text_en,
              offset: 120,
            });
          }
          // if (this.lan == "en") {
          //   res.data[0].exh_begtime = res.data[0].exh_begtime_en;
          //   res.data[0].exh_endtime = res.data[0].exh_endtime_en;
          // }
          if(this.lan == "ch") {
            if(res.data.exh_param_text){
              res.data.exh_param_text = res.data.exh_param_text.split('\n').join('<br/>')
            }

          }else{
            if(res.data.exh_param_text_en){
              res.data.exh_param_text_en = res.data.exh_param_text_en.split('\n').join('<br/>')
            }

          }
          if(res.data.broadcast_cz == 1 || res.data.broadcast_en_cz == 1){
             if(res.data.broadcast_en_cz == 1){
              this.exhibitorsTabId = 'oe';
             }else{
              this.exhibitorsTabId = 'de';
             }

          }else{
            this.exhibitorsTabId = '';
          }
         // debugger
          that.intro = res.data;
          console.log("展会介绍" , that.intro);

      this.getCountryStateApi();
          //localStorage.setItem("exhibition" + that.exhibitionId + that.lan, JSON.stringify(that.intro))
          // that.intro = {};

          if (res.data.exh_state == 3) return (that.activeName = "2");
          if (
            res.data.exhibition_id == "32" &&
            res.data.exh_state == 4 &&
            res.data.broadcast_cz != 0
          )
            return (that.activeName = "5");
          if (
            res.data.exhibition_id != "32" &&
            res.data.exh_type == 1 &&
            res.data.exh_details_show == 1
          )
            return (that.activeName = "3");
        }
      );

      //获取直播间分类
      // const liveClass = localStorage.getItem("liveClass");
      // if (!liveClass) {
        getBroadcastClass({ exhibition_id: this.exhibitionId }).then((res) => {
          if (res.type != "1") {
            if (this.lan == "ch") {
              return this.$message.error({ message: res.text, offset: 120 });
            }
            return this.$message.error({ message: res.text_en, offset: 120 });
          }
          const data = res.data;
          // data.splice(0, 0, {
          //   broadcast_class_id: "",
          //   broadcast_class_name: "全部",
          //   broadcast_class_name_en: "All",
          // });
          this.liveClass = data;

          // for(var index in this.liveClass){
          //   for(var item in this.liveClass[index]){
          //     console.log(item + ": " + this.liveClass[index][item]);
          //   }
          //   console.log("---------------------------------------------------------------")
          // }

        });

      //获取招聘岗位
      selectRecruitPost({ exhibition_id: this.exhibitionId }).then((res) => {
        if(res.type == 1){
          const data = res.data;
          // console.log("data：", data);
          for(var index in data) {
            if (data[index].super_id == null) {
              this.recruitList.push({
                value: data[index].id,
                label: data[index].name,
                children: []
              })
            }
          }
          for(var index in data){
            if(data[index].super_id != null){
              for(var i in this.recruitList){
                if(this.recruitList[i].value == data[index].super_id){
                  // this.$set(this.recruitList[i],"children",data[index])
                  this.recruitList[i].children.push({
                    value:data[index].id,
                    label:data[index].name,
                    super_id:data[index].super_id
                  })
                }
              }
            }
          }
          console.log("岗位：" , this.recruitList);
        }else{
          return this.$message.error({ message: res.text, offset: 120 });
        }
      });

      //获取招聘会岗位数量
      getJobFairNum({ exhibition_id: this.exhibitionId }).then((res)=> {
        if(res.type == 1){
          this.jobsNum = res.data[0].count;
          console.log("岗位数量： " ,res.data[0].count);
        }
      });

      //this.getWebStock();
      // this.getguestsList();
      //this.getExhList();
      this.getChannel();
      this.getNoticeAll();
    },
    handleExhListOne(val) {
      this.pageOne = val.page;
      this.getCompanySelectList();
    },
    handleExhListForm(val) {
      this.pageForm = val.page;
      //this.getExhList();
    },
    handleExhList(val) {
      this.page = val.page;
      // if(this.activeName == 1){
      //     this.getCompanySelectList();
      //     // this.getExhList();
      // }else if( this.activeName == 4){
      //     this.numberPage = 9;
      //     this.getDetailLiveUser();

      // }else if( this.activeName == 5){
      this.numberPage = 6;
      // this.getDetailLiveUserJoinList();
      this.getguestsList();

      // }else{
      //     this.getExhList();
      // }
    },
    getCompanySelectList() {
      // PC分享进入
      function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {

            return pair[1];
          }
        }
        return false;
      }
      var room_id = getQueryVariable("room_id");
      var exhibition_id = getQueryVariable("exhibition_id");
      console.log("room_id=" + room_id);
      console.log("exhibition_id=" + exhibition_id);
      if (room_id && !this.isShowDetails) {
        this.isShowDetails = true;
        // 隐藏4个视频
        this.video4 = false;
        this.showUpParticipants([{
          // token: this.token,
          user_id: room_id,
          ExhibitionId: exhibition_id,
        }]);
        /*if (this.indexNum == 0) {
          this.indexNum++;
          this.showUpParticipants(data);
        } else {
          this.indexNum++;
        }*/

        //return false;
      } else {
        room_id = 0;
      }
      console.log('-----------firmQualityNumber-----------',this.firmQualityNumber)
      this.liveList = [];
      this.loading = true;
      let props = {};
      let jobId = '';
      if(this.recruitClassNumber!= '' && this.recruitClassNumber.length > 0){
        jobId = this.jobValue[1];
      }
      //
      if (this.abcString != "") {
        this.liveClassNumber = "";
        props = {
          exhibition_id: this.exhibitionId,
          jobId: jobId,
          keyword: this.companyName,
          locationName: this.locationName,
          abc: this.abcString=='全部'?'':this.abcString,
          currentPage: this.pageOne,
          numberPage: this.numberPageOne,
          //orderby: this.orderby,
          //renqi: this.renqi_type,
          broadcast_class_id: "", //招聘岗位
          user_state: this.forumTabsTableType,
          lan: this.lan,
          // companyQuality:this.firmQuality[this.firmQualityNumber].label  //企业性质
          companyQuality:this.firmQualityNumber   //企业性质
        };
      } else {
        props = {
          exhibition_id: this.exhibitionId,
          jobId: jobId,
          keyword: this.companyName,
          locationName: this.locationName,
          currentPage: this.pageOne,
          numberPage: this.numberPageOne,
          //orderby: this.orderby,
          //renqi: this.renqi_type,
          broadcast_class_id: this.liveClassNumber, //招聘岗位
          user_state: this.forumTabsTableType,
          lan: this.lan,
          // companyQuality:this.firmQuality[this.firmQualityNumber].label  //企业性质
          companyQuality:this.firmQualityNumber   //企业性质
        };
      }
      if(this.renqi_type != ''){
        props.orderField = 'b.negotiate_num';
        props.orderBy = 'desc';
      }else if(this.orderby != ''){
        props.orderField = 'b.truetime';
        props.orderBy = this.orderby;
      }
      if (this.token != null && this.token != undefined) {
        props.user_user = this.userInfo.user;
        // props.token = this.token;
      }

      if(this.exhibitorsTabId == 'oe'){
        props.register_area = '2';
      }else if(this.exhibitorsTabId == 'de'){
        props.register_area = '1';
      }
      if(this.firmQualityNumber != null && this.firmQualityNumber != ''){
        props.nature = this.firmQualityNumber;
      }
      //直播间显示 0隐藏1显示
      props.broadcast_show=1;
      //状态0未开播1开播2开播下播
      // props.broadcast_state=0;
      //获取展会下的展商
      getCompanysList(props).then((resp) => {
        let res = resp;
        if (res.data == null || res.data == false) {
          res.data = [];
        }

        this.broadcastNum = res.datacount * 1;
        // this.broadcastNum = 1234;
        let s = this.broadcastNum.toString();
        // this.jobsNum.splice(0,this.jobsNum.length);
        for(var i = 0; i < s.length; i++) {
            // this.jobsNum.push(s.slice(i , i + 1));
        }

        if(this.firstNum == -1){
          this.firstNum = this.broadcastNum
        }
        if (res.text_en == "") {
          res.text_en = [];
        }
        if (this.currentPage == 1) {
          this.topLiveList = res.text_en;
        }
        this.liveList = res.data;
        this.totalOne = res.datacount * 1;
        this.loading = false;
        this.getContentWrapHeight();
      });

    },
    clearAll() {
      this.abcString = "";
      this.orderby = "";
      this.renqi_type = "";
      this.companyName = "";
      this.locationName = "";
      this.liveClassNumber = "";
      this.firmQualityNumber = "";
      this.recruitClassNumber = "";
      this.getCompanySelectList();
    },
    chooseAbcSearchItem(item) {
      this.abcString = item;
      this.orderby = "";
      this.renqi_type = "";
      this.companyName = "";
      this.locationName = "";
      this.liveClassNumber = "";
      this.pageOne = 1;
      this.searchResult = true;
      this.getCompanySelectList();
    },
    // 获取论坛
    getExhList() {
      // PC分享进入
      function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
            return pair[1];
          }
        }
        return false;
      }
      var room_id = getQueryVariable("room_id");

      if (room_id) {
        // 隐藏4个视频
        this.video4 = false;
      } else {
        room_id = 0;
      }

      this.liveFormList = [];
      this.loading = true;
      let props = {
        exhibition_id: this.exhibitionId,
        broadcast_type: 2, //this.activeName,
        broadcast_class_id: this.liveClassNumber,
        ckeyword: this.studio,
        keyword: this.companyName,
        locationName: this.locationName,
        currentPage: this.pageForm,
        numberPage: this.numberPageForm,
        orderby: this.orderby || "desc",
        room_id: room_id,
        lg: this.lan == "ch" ? "zh" : "en",
      };
      if (this.token != null && this.token != undefined) {
        props.user_user = this.userInfo.user;
        // props.token = this.token;
      }
      // getBroadcastList(props)
      //直播推介
      broadcast("/Broadcast", props).then((resp) => {
        let res = resp.data;
        // if (res.type != 1 || res.data == null) {
        //   this.loading = false;
        //     return;
        // }
        for (let i = 0; i < res.data.length; i++) {
          //if (this.lan == "en" && res.data[i].broadcast_type == 2) {
          if (this.lan == "en") {
            res.data[i].broadcast_name = res.data[i].broadcast_name_en;
            res.data[i].broadcast_introduce = res.data[i].broadcast_introduce_en;
            res.data[i].location = res.data[i].location_en;
            res.data[i].user_post = res.data[i].user_post_en;
            res.data[i].truename = res.data[i].truename_en;
            res.data[i].company = res.data[i].company_en;
            res.data[i].broadcast_class_name =res.data[i].broadcast_class_name_en;
          }
          if (
            res.data[i].broadcast_logo &&
            res.data[i].broadcast_logo != null
          ) {
            res.data[i].new_broadcast_logo = res.data[i].broadcast_logo.replace(
              "https://exhxcx.shippingchina.com/Public/uploads",
              "https://www.wiffa-exh.com/Public/uploads"
            );
          } else {
            res.data[i].new_broadcast_logo = "";
          }
        }
        // console.log(res.data);
        this.liveFormList = res.data;
        this.totalForm = res.datacount * 1;
        this.loading = false;
        this.getContentWrapHeight();
      });
    },
    //展会详情页观展人员列表
    getDetailLiveUser() {
      this.liveList = [];
      this.loading = true;
      let props = {
        exhibition_id: this.exhibitionId,
        broadcast_type: this.activeName,
        broadcast_class_id: this.liveClassNumber,
        keyword: this.studio,
        ckeyword: this.companyName,
        locationName: this.locationName,
        currentPage: this.page,
        numberPage: this.numberPage,
        lg: this.lan == "ch" ? "zh" : "en",
      };
      if (this.token != null && this.token != undefined) {
        props.user_user = this.userInfo.user;
      }
      // getDetailLiveUser(props).then(res => {
      //     //console.log(res.data);
      //     this.visitorsdata = res.data || [];
      //     this.showType = res.option;
      //     this.total = res.datacount * 1;
      //     this.loading = false;
      //     this.getContentWrapHeight();
      // });
    },
    //展会详情页参展人员列表
    getDetailLiveUserJoinList() {
      this.liveList = [];
      this.loading = true;
      let props = {
        exhibition_id: this.exhibitionId,
        broadcast_type: this.activeName,
        broadcast_class_id: this.liveClassNumber,
        keyword: this.studio,
        ckeyword: this.companyName,
        locationName: this.locationName,
        currentPage: this.page,
        numberPage: this.numberPage,
        lg: this.lan == "ch" ? "zh" : "en",
      };
      if (this.token != null && this.token != undefined) {
        props.user_user = this.userInfo.user;
      }
      // getDetailLiveUserJoinList(props).then(res => {
      //     //console.log(res.data);
      //     this.participantsdata = res.data || [];
      //     this.showType = res.option;
      //     this.total = res.datacount * 1;
      //     this.loading = false;
      //     this.getContentWrapHeight();
      // });
    },

    searchGuestsList() {
      this.page = 1;
      this.numberPage = 9;
      this.getguestsList();
    },

    getguestsList() {
      // this.liveList = [];
      // this.loading = true;

      if (this.intro.broadcast_cz==null) {
        setTimeout(this.getguestsList,100);
        return;
      }



      let props = {
        exhibition_id: this.exhibitionId,
       // broadcast_type: this.activeName,
        company_name: this.guestsCompanyName,
        business: this.guestsBusiness,
        location: this.guestsLocation,
        currentPage: this.page,
        numberPage: 6,
        lg: this.lan,
        user_state:
          this.guestsTabsTableType == "" ? 2 : this.guestsTabsTableType
      };
      if (this.token != null && this.token != undefined) {
        props.user = this.userInfo.user;
      }
      //嘉宾名单
      getExhibitionUser(props).then((resp) => {
          let res = resp;
          this.guestsListdata = res.data || [];
          this.guests_is_show = res.is_show;


           (this.guests_datacount = Number(res.datacount)),
            (this.guests_showSouNum = Number(res.datacount));
         // (this.guests_datacount = res.showCountNum),
         //   (this.guests_showSouNum = res.showSouNum);
          //this.total = res.showSouNum;
          this.total = Number(res.datacount);
          //   // this.loading = false;
          this.getContentWrapHeight();
          if (
            this.page == 1 &&
            this.guestsBusiness == "" &&
            this.guestsLocation == "" &&
            this.guestsCompanyName == ""
          ) {
            localStorage.setItem(
              "guestsListpage" +
                this.page +
                this.lan +
                this.guestsTabsTableType,
              JSON.stringify(res)
            );
          }
        });
        getExhibitionUserCount({exhibition_id: this.exhibitionId, user_id: this.userInfo.user_id}).then((res) => {
          let data = res.data;
          this.showGuestsType = parseInt(data.count) > 0;
        });

        // axios
        //   .get("http://192.168.1.203:8080/guest", {
        //     params: props,
        //   })
        //   .then((resp) => {
        //     let res = resp.data;
        //     this.guestsListdata = res.data || [];
        //     this.showGuestsType = res.canview;
        //     this.guests_is_show = res.is_show;
        //     (this.guests_datacount = res.showCountNum),
        //       (this.guests_showSouNum = res.showSouNum);
        //     this.total = res.showSouNum;
        //     //   // this.loading = false;
        //     this.getContentWrapHeight();
        //     if (
        //       this.page == 1 &&
        //       this.guestsBusiness == "" &&
        //       this.guestsLocation == "" &&
        //       this.guestsCompanyName == ""
        //     ) {
        //       localStorage.setItem(
        //         "guestsListpage" +
        //           this.page +
        //           this.lan +
        //           this.guestsTabsTableType,
        //         JSON.stringify(res)
        //       );
        //     }
        //   });

    },
    //进博会线下报名
    handleOfflineToken() {
      this.title = this.language.helpfulHints;
      this.promptContent = this.language.notLogin;
      this.type = 9999;
      this.showHint = true;
    },

    //用户是否登录
    handleToken() {
      this.title = this.language.helpfulHints;
      this.promptContent = this.language.notLogin;
      if (
        this.exhibitionId == "33" ||
        this.exhibitionId == "36" ||
        this.exhibitionId == "37"
      ) {
        this.type = 8888;
      } else {
        this.type = 1;
      }
      this.showHint = true;
    },
    //获取通知
    // getNoticeList() {
    //     noticeList({
    //       position:this.exhibitionId,
    //     }).then(res => {
    //     this.datacount = res.datacount * 1;
    //     if(res.data && res.data.length != 0){
    //         res.data.forEach(item => {
    //             if (this.lan == "en") {
    //                 item.exh_name = `${item.exh_name_en}`;
    //             }
    //         });
    //         this.dataList = res.data;
    //     }else{
    //         this.dataList = [];
    //     }
    //   });
    // },

    //我要支付
    handleRegister() {
      // this.$emit(
      //     "join-handleRegister",
      //     this.ExhibitionHandleEnum.BUY_TICKET,
      //     this.exhibitionId
      // );

      // //我要支付
      // if (this.token === null || this.token === undefined) {
      //     this.title =  this.language.helpfulHints;
      //     this.promptContent = this.language.notLogin;
      //     this.type = 4;
      //     this.loginData = {type: this.ExhibitionHandleEnum.BUY_TICKET, exhibitionId: this.exhibitionId}
      //     this.showHint = true;
      // // window.location.href = "login.html?type=4&exhibitionId=" + exhibition_id;
      // }else{
      //     let params = "exhibitionId=" + exhibition_id;
      //     let encodeData = window.btoa(window.encodeURIComponent(params));
      //     return window.location.href = "ticketsRegister.html?" + encodeData;
      // }
      if (
        this.token == null ||
        this.token == undefined ||
        this.exhibitionId == null
      ) {
        this.loginData = {
          type: this.ExhibitionHandleEnum.BUY_TICKET,
          exhibitionId: this.exhibitionId,
        };
        this.handleToken();
        return;
      }
      getExhticketUserCount({exhibition_id: this.exhibitionId, user_id: this.userInfo.user_id}).then(res => {
          let data = res.data;
          let exhibitionNum = data.exhibitionNum;
          let exhibitionViewingNum = data.exhibitionViewingNum;
          if(res.type == 1 && (exhibitionNum + exhibitionViewingNum) > 0){
            let userName = this.lan == 'ch'?(this.userInfo.true_name||this.userInfo.true_name_en):(this.userInfo.true_name_en)||this.userInfo.true_name;

            let message = language().ticketsTips1.replace('{0}', userName);
            let msg = '';
            if(exhibitionViewingNum > 0){
              msg += language().ticketsTips2.replace('{0}', exhibitionViewingNum);
            }
            if(exhibitionNum > 0){
              if(msg == ''){
                msg += language().ticketsTips3.replace('{0}', exhibitionNum);;
              }else{
                msg += (this.lan == 'ch'?'和':' and ') + language().ticketsTips3.replace('{0}', exhibitionNum);;
              }
            }
            message = message.replace('{1}', msg)
            MessageBox({
              title: "",
              message: message,
              confirmButtonText: language().confirm,
              cancelButtonText: language().cancel,
              dangerouslyUseHTMLString:true,
              showCancelButton: true,
              // type: 'warning'
            }).then(() => {
              //确认
              window.location.href = ticketsRegisterUrl(
                this.ExhibitionHandleEnum.BUY_TICKET,
                this.exhibitionId
              )
            }).catch(() => {
              //取消
            });
          }else{
            window.location.href = ticketsRegisterUrl(
              this.ExhibitionHandleEnum.BUY_TICKET,
              this.exhibitionId
            )
          }


        });

    },

    // 进博会线下报名
    handleOfflineRegistration() {
      if (this.lan == "ch") {
        this.$message.error("报名已结束");
        // this.$alert('报名已结束')
      } else {
        this.$message.error("Registration has ended");
      }
      // if (
      //     this.token == null ||
      //     this.token == undefined ||
      //     this.exhibitionId == null
      // ) {
      //     this.loginData = { type: this.ExhibitionHandleEnum.BUY_TICKET, exhibitionId: this.exhibitionId };
      //     this.handleOfflineToken();
      //     return;
      // }

      // return (window.location.href = 'offlineRegistration.html?' + this.exhibitionId);
    },

    //1观展 2参展
    handleAttend(type) {
      if (
        this.token == null ||
        this.token == undefined ||
        this.exhibitionId == null
      ) {
        this.loginData = { type: type, exhibitionId: this.exhibitionId };
        this.handleToken();
        return;
      }
      return (window.location.href = tickUrl(type, this.exhibitionId));
    },
    getConfirm(type, loginData) {
      //用户没登录

      if (type == 1) {
        window.location.href =
          "login.html?type=" +
          loginData.type +
          "&exhibitionId=" +
          loginData.exhibitionId;
      }
      if (type == 4) {
        window.location.href =
          "login.html?type=4&exhibitionId=" + loginData.exhibitionId;
      }
      if (type == 9999) {
        window.location.href =
          "login.html?type=9999&exhibitionId=" + loginData.exhibitionId;
      }
      if (type == 8888) {
        window.location.href =
          "login.html?type=8888&exhibitionId=" + loginData.exhibitionId;
      }
    },
    //新进入直播间
    newHandleInfo(data) {

      let _this = this;
      //console.log("￥￥￥￥￥￥￥￥", data);
      if (
        this.token == null ||
        this.token == undefined ||
        this.exhibitionId == null
      ) {
        this.loginData = { exhibitionId: this.exhibitionId };
        this.handleToken();
        return;
      }
      if (!isInternet() && data.state == this.stateEnum.JOIN_DISCUSS) {
        return (this.downloadShow = true);
      }
      this.broadcastId = data.id;

      // console.log("e===" + this.broadCastList.user_id);
      // console.log("0===" + this.userInfo.company);

      if(this.userInfo.user_nature == 3 && this.broadCastList.user_id != this.userInfo.user_id) {
        MessageBox({
          title: "",
          message: "您作为招聘企业不能参加其他公司的面试",
          confirmButtonText: language().confirm,
          cancelButtonText: language().cancel,
          showCancelButton: false,
        }).then(() => {
          //确认
        }).catch(() => {
          //取消
        });
        return;
      };

      const param = {
        client_id: this.$store.state.live.client_id,
        lan:this.lan
      };
      getLiveUrl({token: this.token,broadcast_id: data.id}).then((res) => {

        if (res.type == 1) {
          let name = Cookie.get("lang") == 'ch' ? (this.userInfo.true_name || this.userInfo.true_name_en) : (this.userInfo.true_name_en || this.userInfo.true_name);
          return (window.location.href =
            windowsGoTo() + roomUrl(res.data[0], name));
        } else if (res.type == 11){
          MessageBox({
            title: "",
            message: Cookie.get("lang")=='ch'?res.text:res.text_en,
            confirmButtonText: language().confirm,
            cancelButtonText: language().cancel,
            showCancelButton: false,
            // type: 'success'
          }).then(() => {
            //确认
          }).catch(() => {
            //取消
          });

          this.showUpParticipants(this.exh_item,this.nowJobId);

        } else if (res.type == 'e1'){
          MessageBox({
            title: "",
            message: Cookie.get("lang")=='ch'?res.text:res.text_en,
            confirmButtonText: language().buyTicket,
            cancelButtonText: language().cancel,
            showCancelButton: true,
            // type: 'error'
          }).then(() => {
            //确认
            let params = "exhibitionId=" + this.exhibitionId;
            let encodeData = window.btoa(window.encodeURIComponent(params));
            localStorage.setItem("buyBackUrl", location.href);
            window.location.href = "ticketsRegister.html?" + encodeData;
          }).catch(() => {
            //取消
          });
        }  else {
          this.$message.error({ message: this.lan=='ch'?res.text:res.text_en, offset: 120 });
        }
      });
      // axios
      //   .get("http://192.168.1.203:8080/room/" + data.id, {
      //     params: props,
      //   })
      //   .then((res) => {
      //     console.log("##$#$#R$#", res.data);

      //     if (res.data.type == 200) {
      //       return (window.location.href =
      //         windowsGoTo() + roomUrl(res.data, this.userInfo.true_name));
      //     } else if (res.data.type == 501) {
      //       this.$message.error({ message: res.data.msg, offset: 120 });
      //       setTimeout(function() {
      //         return (window.location.href = ticketsRegisterUrl(
      //           4,
      //           _this.exhibitionId
      //         ));
      //       }, 2000);
      //     } else {
      //       this.$message.error({ message: res.data.msg, offset: 120 });
      //     }
      //   });

      //获取是否可以无票进入直播间
      // liverRoomBuy({}).then((res) => {
      //   // console.log(res);
      //   // return;
      //   if (res == 0) {
      //     const props = {
      //       token: this.token,
      //       broadcast_id: data.id,
      //     };
      //     //进入直播间
      //     this.$store
      //       .dispatch("getLiveInfo", props)
      //       .then((res) => {
      //         console.log("###########===#######", res);

      //         if (res.type != "1") {
      //           if (res.type == "e1") {
      //             this.$message.error({
      //               message: this.lan == "ch" ? res.text : res.text_en,
      //               offset: 135,
      //             });
      //             setTimeout(function() {
      //               return (window.location.href = ticketsRegisterUrl(
      //                 4,
      //                 _this.exhibitionId
      //               ));
      //             }, 2000);
      //           }
      //           if (isEmpty(res.data)) {
      //             if (this.lan == "ch") {
      //               return this.$message.error({
      //                 message: res.text,
      //                 offset: 120,
      //               });
      //             } else {
      //               this.$message.error({ message: res.text_en, offset: 120 });
      //             }
      //             return;
      //           }
      //           const data = res.data[0];
      //           if (data.type != 1) {
      //             if (this.lan == "ch") {
      //               return this.$message.error({
      //                 message: res.text,
      //                 offset: 120,
      //               });
      //             } else {
      //               this.$message.error({ message: res.text_en, offset: 120 });
      //             }
      //             return;
      //           }
      //           const waitData = {
      //             token: this.token,
      //             roomid: data.roomid,
      //           };
      //           //需要排队
      //           if (res.data[0].type == 1) {
      //             this.waitData = waitData;
      //             this.visibleLine = true;
      //           }
      //           return;
      //         }
      //         const data = res.data[0];
      //         return window.open(
      //           windowsGoTo() + roomUrl(data, this.userInfo.true_name)
      //         );
      //         const goData = {
      //           token: this.token,
      //           roomid: data.roomid,
      //         };
      //       })
      //       .catch(() => {});
      //   } else {
      //     const props = {
      //       token: this.token,
      //       broadcast_id: data.id,
      //     };
      //     //进入直播间
      //     this.$store
      //       .dispatch("getNewLiveUrl", props)
      //       .then((res) => {
      //         if (res.type != "1") {
      //           if (isEmpty(res.data)) {
      //             if (this.lan == "ch") {
      //               return this.$message.error({
      //                 message: res.text,
      //                 offset: 120,
      //               });
      //             } else {
      //               this.$message.error({ message: res.text_en, offset: 120 });
      //             }
      //             return;
      //           }
      //           const data = res.data[0];
      //           if (data.type != 1) {
      //             if (this.lan == "ch") {
      //               return this.$message.error({
      //                 message: res.text,
      //                 offset: 120,
      //               });
      //             } else {
      //               this.$message.error({ message: res.text_en, offset: 120 });
      //             }
      //             return;
      //           }
      //           const waitData = {
      //             token: this.token,
      //             roomid: data.roomid,
      //           };
      //           //需要排队
      //           if (res.data[0].type == 1) {
      //             this.waitData = waitData;
      //             this.visibleLine = true;
      //           }
      //           return;
      //         }
      //         const data = res.data[0];
      //         return (window.location.href =
      //           windowsGoTo() + roomUrl(data, this.userInfo.true_name));
      //         const goData = {
      //           token: this.token,
      //           roomid: data.roomid,
      //         };
      //       })
      //       .catch(() => {});
      //   }
      // });
    },

    //获取直播间进入链接 -- 预约
    handleLive(data) {
      let _this = this;
      console.log("===取消===", data);
      if (
        this.token == null ||
        this.token == undefined ||
        this.exhibitionId == null
      ) {
        this.loginData = { exhibitionId: this.exhibitionId };
        this.handleToken();
        return;
      }
      if (!isInternet() && data.state == this.stateEnum.JOIN_DISCUSS) {
        return (this.downloadShow = true);
      }
      this.broadcastId = data.id;
      const props = {
        token: this.token,
        broadcast_id: data.id,
      };

      if (data.state == this.stateEnum.SEE_CONTACT) {
        //查看联系方式
        selectContact(props)
          .then((res) => {
            if (res.type != "1") {
              if (this.lan == "ch") {
                return this.$message.error({ message: res.text, offset: 120 });
              }
              return this.$message.error({ message: res.text_en, offset: 120 });
            }
            this.$alert(
              res.data[0].broadcast_contact,
              this.language.hintContact,
              {
                confirmButtonText: this.language.confirm,
                callback: (action) => {},
              }
            );
          })
          .catch(() => {});
        return;
      }

      //取消预约
      if (data.state == this.stateEnum.CANCELSUB) {
        // subscribeCancel(props).

        // then(res => {
        //     if (res.type != "1") {
        //         if (this.lan == "ch") {
        //             return this.$message.error({ message: res.text, offset: 120 });
        //         }
        //         return this.$message.error({ message: res.text_en, offset: 120 });
        //     }
        //     if (this.lan == "ch") {
        //         this.$message.success({ message: res.text, offset: 120 });
        //     } else {
        //         this.$message.success({ message: res.text_en, offset: 120 });
        //     }
        //     var newObjack = this.liveList.filter( item =>{
        //         return item.broadcast_id == res.datacount
        //     })
        //   this.$refs['ontoone'][data.k].aloneData.subscribe_type = 0;
        //    // this.$set(newObjack[0],'subscribe_type', '0')
        //     // this.getExhList();
        // });

        this.$confirm(
          this.lan == "ch"?"是否取消该预约？":"Do you want to cancel the appointment",
            this.lan == "ch"?"提示":"Tips",
          {
            confirmButtonText: this.lan == "ch"?"确定":"confirm",
            cancelButtonText: this.lan == "ch"?"取消":"cancel",
            type: "warning",
          }
        )
          .then(() => {
            //取消预约
            // user_id: this.userInfo.user_id,
            cancelBroadcastSubscribe({user_id: this.userInfo.user_id,broadcast_id: props.broadcast_id}).then((res) => {
              if (res.type == 1) {
                this.$message.success({
                  message: res.text,
                  offset: 120,
                });
                this.$refs["ontoone"][data.k].aloneData.subscribe_type = 0;
                this.$refs["ontoone"][data.k].aloneData.subscribe_count--;
              } else {
                this.$message.error({ message: res.text, offset: 120 });
              }
            });
            // axios
            //   .delete("http://192.168.1.203:8080/subject/" + props.broadcast_id)
            //   .then((res) => {
            //     if (res.data.status == 200) {
            //       this.$message.success({
            //         message: res.data.mess,
            //         offset: 120,
            //       });
            //       this.$refs["ontoone"][data.k].aloneData.subscribe_type = 0;
            //     } else {
            //       this.$message.error({ message: res.data.mess, offset: 120 });
            //     }
            //   });
          })
          .catch(() => {});
      }
    },
    search() {
      //选择条件为空
      if((this.$refs.wordLocation.value == null || this.$refs.wordLocation.value == "") &&
          (this.$refs.post.value == null || this.$refs.post.value == "") &&
          (this.$refs.companyXZ.value == null || this.$refs.companyXZ.value == "") &&
          (this.$refs.comName.value == null || this.$refs.comName.value == "")){
        //弹出提示框
        this.$message('至少选择一个查询项');
        this.searchResult = false;
        return;
      }
      console.log("值=" + this.$refs.post.value + ",liveClasssNumber= " + this.liveClassNumber);
      this.zpPost = this.$refs.post.value;
      //console.log("111:" + this.zpPost);
      this.page = 1;
      this.abcString = "";
      this.searchResult = true;
      // this.changeOrderby('asc');
      this.getCompanySelectList();
      // this.getExhList();
    },
    handleForum(id) {
      let _this = this;
      if (
        this.token == null ||
        this.token == undefined ||
        this.exhibitionId == null
      ) {
        this.handleToken();
        return;
      }
      if (!isInternet()) {
        return (this.downloadShow = true);
      }
      const props = {
        token: this.token,
        broadcast_id: id,
      };

      getNewLiveUrl(props).then((res) => {
        if (res.type != "1") {
          if (res.type == "e1") {
            this.$message.error({
              message: this.lan == "ch" ? res.text : res.text_en,
              offset: 135,
            });
            setTimeout(function() {
              return (window.location.href = tickUrl(1, _this.exhibitionId));
            }, 2000);
          }
          if (this.lan == "ch") {
            return this.$message.error({ message: res.text, offset: 120 });
          }
          return this.$message.error({ message: res.text_en, offset: 120 });
        }
        const data = res.data[0];
        sessionStorage.setItem("userType", res.prcurl);
        let name = Cookie.get("lang") == 'ch' ? (this.userInfo.true_name || this.userInfo.true_name_en) : (this.userInfo.true_name_en || this.userInfo.true_name);
        return (window.location.href =
          windowsGoTo() + roomUrl(data, name));
      });
    },
    getWebStock() {
      var that = this;
      init({ token: this.token }, onmessage);

      function onmessage(data) {
        that.clientId = data.data.client_id;
        console.log(data);
        if (data.data.type == "2") {
          that.warnConten = data.data;
          that.visibleLine = false;
          that.warnVisible = true;
        }
      }
    },
    handleWatch(data) {
      if (
        this.token == null ||
        this.token == undefined ||
        this.exhibitionId == null
      ) {
        this.handleToken();
        return;
      }
      this.watchTitle = `${this.language.playbackList} - ${data.broadcast_name}`;
      this.initCont = data;
      this.dialogShow = true;
    },
    handleGzInfo(row, initCont, fn) {
      if (fn == 1) {
        const props = {
          roomid: initCont.broadcast_id,
          broadcast_playback_id: row.broadcast_playback_id,
        };
        window.open(videoUrl(props));
        //window.location.href = videoUrl(props);
        return;
      }
    },
    handleCarousel(index) {
      if (this.carouselType == 2) {
        this.carouselImage.map((_, _index) => {
          if (_index == index) {
            document.getElementById(`video${_index}`).play();
          } else {
            document.getElementById(`video${_index}`).pause();
          }
        });
      }
    },
    //手机播放视频
    ac() {
      this.a = false;
    },
    bc() {
      this.b = false;
    },
    cc() {
      this.c = false;
    },
    dc() {
      this.d = false;
    },
    playv(d) {
      d();
    },

    // 论坛分享邀请码
    showImg1(e) {
      let data = {
        exhibition_id: this.exhibitionId,
        broadcast_id: e.broadcast_id,
        currentTab: this.activeName,
      };
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
     reqest.send(reqest.adminapi+"MakeQr/getExhibitionRr", data)
        .then((res) => {
          loading.close();
          if (res.type == "1") {
            // this.imgSrc = res.data.data.qr_base64;
            this.imgSrcList = res.data.img;
            this.showImgDialogFormVisible = true;
            // this.$refs.dialogChild.receiveDialogFormVisible = true;
            // console.log(res.data.data.qr_base64,'eeeeeee')
          } else {
            if (this.lan == "ch") {
              return this.$message.error({ message: res.text, offset: 120 });
            }
            return this.$message.error({ message: res.text_en, offset: 120 });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    // 邀请码分享
    showImg(e) {
      let data = {
        exhibition_id: this.exhibitionId,
        broadcast_id: e.broadcast_id,
        currentTab: this.activeName,
      };
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      reqest.send(reqest.adminapi+"MakeQr/getExhibitionRr", data).then((res) => {
          loading.close();
          if (res.type == "1") {
            // this.imgSrc = res.data.qr_base64;
            this.imgSrcList = res.data.img;
            this.showImgDialogFormVisible = true;
            // this.$refs.dialogChild.receiveDialogFormVisible = true;
            // console.log(res.data.data.qr_base64,'eeeeeee')
          } else {
            if (this.lan == "ch") {
              return this.$message.error({ message: res.text, offset: 120 });
            }
            return this.$message.error({ message: res.text_en, offset: 120 });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    changeImgSrc(index) {
      this.imgSrcIndex = index;
    },

    broadCastTotalHandleExhList(val) {
      this.broadCastTotalPage = val.page;

      let params = {
        user_id: this.dialogUserId,
        finally_in_exhibtion: this.dialogFinallyInExhibtion,
      };
      this.showParticipants(params);
    },

    showUpParticipants(item,jobId=0) {
      this.exh_item = item;
      this.nowJobId = parseInt(jobId);
      let e = item[0];
      let index = 0;
      if(item.length > 0){
        index = item[1];
      }
      this.loadData(e.ExhibitionId);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let data = {
        // token: this.token,
        user_user: this.userInfo.user,
        //   user_id: e.user_id,
        //   exhibition_id: e.finally_in_exhibtion,

        currentPage: this.broadCastTotalPage,
        numberPage: this.broadCastTotalNumberPage,
      };

      // 获取当前展商在当前展会下得所有直播间
      getCompanysDetails({
        user_id: e.user_id,
        login_user_id: this.userInfo.user_id,
        exhibition_id: e.ExhibitionId
      }).then(
        (resp) => {
          let res = resp;
          loading.close();
          this.dialogUserId = e.user_id;
          this.dialogFinallyInExhibtion = e.ExhibitionId;
          this.broadCastTotal = res.count * 1;

          let broadCast = res.data.broadCast;
          // console.log("反馈==" , this.liveList[index]);
          if(this.liveList[index]){
            let d = broadCast.every((res) => {
                res.broadcast_state == 1
                    ? (this.liveList[index].broadcast_state = e.broadcast_state)
                    : ""
            });
          }

          this.broadCastList = res.data;
          //展示展商直播间详情
          this.showParticipantsDialogFormVisible = true;
          this.emailHidden = this.broadCastList.exhticket_count
          console.log("this.broadCastList.exhticket_count邮箱=" + this.broadCastList.exhticket_count);
          console.log("邮箱=   " , res);
        }
      );
    },
    showParticipants(e, index) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let data = {
        // token: this.token,
        user_user: this.userInfo.user,
        user_id: e.user_id,
        exhibition_id: e.finally_in_exhibtion,

        currentPage: this.broadCastTotalPage,
        numberPage: this.broadCastTotalNumberPage,
      };

      // 获取直播间
      //showBroadCast(data)
      getLiveRoom(`/${e.finally_in_exhibtion}/${e.user_id}`).then((resp) => {
        let res = resp.data;
        loading.close();
        this.dialogUserId = e.user_id;
        this.dialogFinallyInExhibtion = e.finally_in_exhibtion;
        this.broadCastTotal = res.count * 1;
        // var newList = e;
        this.broadCastList = res.data;
        var c = 0;
        this.showParticipantsDialogFormVisible = true;
      });
      // axios
      //   .get(
      //     "http://192.168.1.203:8080/" +
      //       e.finally_in_exhibtion +
      //       "/" +
      //       e.user_id
      //   )
      //   .then((resp) => {
      //     let res = res.data;
      //     loading.close();
      //     // if (res.status != "1") {
      //     //     if (this.lan == "ch") {
      //     //         return this.$message.error({ message: res.text, offset: 120 });
      //     //     }
      //     //     return this.$message.error({ message: res.text_en, offset: 120 });
      //     // }

      //     this.dialogUserId = e.user_id;
      //     this.dialogFinallyInExhibtion = e.finally_in_exhibtion;
      //     this.broadCastTotal = res.count * 1;

      //     // var newList = e;
      //     this.broadCastList = res.data;
      //     var c = 0;
      //     // res.data.broadCast.forEach((v,i)=>{
      //     //点击查看展商，如果展商详细信息中直播间有开播，更新外部列表状态为已开播
      //     // console.log(v);

      //     // this.liveList[index].broadcast_state = v.broadcast_state;

      //     // })
      //     // try {
      //     //     res.data.broadCast.forEach((v, i) => {
      //     //         //点击查看展商，如果展商详细信息中直播间有开播，更新外部列表状态为已开播
      //     //
      //     //         this.liveList[index].broadcast_state = v.broadcast_state;
      //     //         if (v.broadcast_state == 1) {
      //     //
      //     //         }
      //     //         this.liveList[index].broadcast_state = v.broadcast_state;
      //     //         if (v.broadcast_state == 1) {
      //     //             throw new Error("EndIterative");
      //     //         }
      //     //
      //     //     })
      //     // }catch(e) {
      //     //     if(e.message!="EndIterative") throw e;
      //     // };

      //     // this.broadCastList.broadCast = JSON.parse(this.broadCastList.broadCast);
      //     // this.participantsBool = false;
      //     // let newResData = e;
      //     // newResData.broadcast_state = res.data.status;
      //     // newResData.is_wait = res.data.is_wait;
      //     // newResData.to_wait = res.data.to_wait;
      //     // newResData.privateTalk = res.data.privateTalk;
      //     // this.$nextTick(()=>{
      //     //     this.participants = newResData;
      //     //     this.participantsBool = true;
      //     //     this.$forceUpdate()
      //     // });
      //     this.showParticipantsDialogFormVisible = true;
      //   });

      // this.showParticipantsDialogFormVisible = true;
    },

    // 跨域文件下载
    downloadIamge(url, fileName) {
      url = url.replace(/\\/g, "/");
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      xhr.onload = () => {
        if (xhr.status == 200) {
          let data = xhr.response;
          let name = fileName;

          var urlObject = window.URL || window.webkitURL || window;
          var export_blob = new Blob([data]);
          var save_link = document.createElementNS(
            "http://www.w3.org/1999/xhtml",
            "a"
          );
          save_link.href = urlObject.createObjectURL(export_blob);
          save_link.download = name;
          save_link.click();
        }
      };

      xhr.send();
    },
    imgDown() {
      // this.downloadIamge(this.imgSrcList[this.imgSrcIndex], 'pic.jpg')
      location.href =
        reqest.apiUrl+"/Home/Pub/downloadfile?file_path=" +
        this.imgSrcList[this.imgSrcIndex];
    },

    // imgDown(){
    //     var alink = document.createElement("a");
    //     alink.href = this.imgSrcList[this.imgSrcIndex];
    //     alink.download = "pic.jpg"; //图片名
    //     alink.click();
    //     this.showImgDialogFormVisible = false;
    // },

    cancelImg() {
      this.showImgDialogFormVisible = false;
    },

    // 分享链接
    showPcUrl(e) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let data = {
        exhibition_id: this.exhibitionId,
        broadcast_id: e.broadcast_id,
      };
      //获取直播间分类
      pcShareLink(data).then((res) => {
        loading.close();
        if (res.type != "1") {
          if (this.lan == "ch") {
            return this.$message.error({ message: res.text, offset: 120 });
          }
          return this.$message.error({ message: res.text_en, offset: 120 });
        }
        this.pcUrl = res.data;
        this.showPcUrlDialogFormVisible = true;
      });
    },
    copyPcUrl() {
      let url = this.pcUrl;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success",
      });
      oInput.remove();
    },

    /**
     * 获取云展说明分类
     */
    getNoticeAll(){
      let params = {
        exhibition_id: this.exhibitionId
      };
      getNoticeAll(params).then((resp) => {
        let res = resp;
        if (resp.type == 1) {
          let obj = res.data || [];
          let chIndex=1;
          let enIndex=1;

          let chNotice=""
          let enNotice=""
          for(let row of obj){
            if (row.use_edition==2) {
              chNotice+=chIndex+++"."+row.send_text
              enNotice+=enIndex+++"."+row.send_text_en
            }else if (row.use_edition==1) {
             enNotice+=enIndex+++"."+row.send_text_en
            }else  if(row.use_edition==0){
              chNotice+=chIndex+++"."+row.send_text
            }
          }
          console.log(this.lan)
          if (this.lan == "ch") {
            this.allNotice=chNotice
          }else{
            this.allNotice=enNotice
          }
        }
      });
    },
    getChannel() {
      let params = {
        exhibition_id: this.exhibitionId,
        lan: this.lan,
      };
      //获取展会介绍信息
      getExhibitionChannel(params).then((resp) => {
        let res = resp;
        if (res.type == 1) {
          let obj = res.data || [];
          /*if (obj.length > 0) {
            obj.forEach((item, i) => {
              item.content = item.content.replace(/(\r\n)|(\n)/g, "<br />");
            });
          }*/
          this.ChannelList = obj;
          if(obj.length > 0){
            this.ChannelConnectId = obj[0].id + "";
          }

          // for(var index in obj){
          //   for(var item in obj[index]){
          //     console.log(item + ":" + obj[index][item]);
          //   }
          //     console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
          // }

          //this.getChannelConnect();
        }
      });
      // axios
      //   .get(
      //     "http://192.168.1.203:8080/channel/" +
      //       this.exhibitionId +
      //       "/" +
      //       this.lan
      //   )
      //   .then((resp) => {
      //     let res = resp.data;

      //     if (res.status == 200 && res.data.length > 0) {
      //       this.ChannelList = res.data || [];

      //       this.ChannelConnectId = res.data[0].id + "";
      //       // this.descriptionActiveName = res.data[o]
      //       this.getChannelConnect();
      //       //localStorage.setItem("channel"+this.exhibitionId+this.lan, JSON.stringify(res.data));
      //     } else {
      //       //   if (this.lan == "ch") {
      //       //     return this.$message.error({message: res.text, offset: 120});
      //       //   }
      //       //   return this.$message.error({message: res.text_en, offset: 120});
      //     }
      //   });
      // }else{
      //   ChannelList = JSON.parse(ChannelList);
      //   this.ChannelList = ChannelList;
      //   this.ChannelConnectId = ChannelList[0].id;
      //   this.getChannelConnect();
      // }
    },

    /**
     * 获取云展说明分类详情
     */
    getChannelConnect() {
      let params = {
        id: this.ChannelConnectId,
      };
      getChannelConnect(params).then((res) => {
        if (res.type == "1") {
          this.ChannelConnect = res.data;
          this.getContentWrapHeight();
        } else {
          if (this.lan == "ch") {
            return this.$message.error({ message: res.text, offset: 120 });
          }
          return this.$message.error({ message: res.text_en, offset: 120 });
        }
      });
    },

    changeDescriptionActiveName(e) {
      //console.log(this.ChannelConnectId);
      //this.getChannelConnect();
      this.getContentWrapHeight();
    },
    changeExhibitorsTab(tab,e) {
      //console.log(tab.name, this.exhibitorsTabId)
      this.search();
    },

    getContentWrapHeight() {
      /*this.$nextTick(() => {
        let contentWrapHeight = this.$refs.form_index.offsetHeight;
        let bgListLength = Math.ceil(contentWrapHeight / 400);
        this.bgList.length = bgListLength;

        this.$forceUpdate();
      });*/
    },
  },
  created() {
    if (!this._isMobile()) {
    }
  },
  mounted() {
    // this.initBanner();
    // this.getNoticeList();
    // if(!this._isMobile()){
    // this.a = false;
    // this.b = false;
    // this.c = false;
    // this.d = false;
    //
    //     this.$refs.videoRef1['disablePictureInPicture'] = true; //disablePictureInPicture的属性改为true
    //    // this.$refs.videoRef1['muted'] = true;
    //     this.$refs.videoRef1.controlsList = 'nodownload' ;
    //
    //     this.$refs.videoRef2['disablePictureInPicture'] = true;
    //    // this.$refs.videoRef2['muted'] = true;
    //
    //     this.$refs.videoRef2.controlsList = 'nodownload' ;
    //     this.$refs.videoRef3['disablePictureInPicture'] = true;
    //     this.$refs.videoRef3.controlsList = 'nodownload' ;
    //     this.$refs.videoRef4['disablePictureInPicture'] = true;
    //
    //     this.$refs.videoRef4.controlsList = 'nodownload' ;
    //   //  this.$refs.videoRef3['muted'] = true;
    //    // this.$refs.videoRef4['muted'] = true;
    //
    // }else{
    //     this.$refs.videoRef1['webkit-playsinline'] = true; //disablePictureInPicture的属性改为true
    //     this.$refs.videoRef2['webkit-playsinline'] = true; //disablePictureInPicture的属性改为true
    //     this.$refs.videoRef3['webkit-playsinline'] = true; //disablePictureInPicture的属性改为true
    //     this.$refs.videoRef4['webkit-playsinline'] = true; //disablePictureInPicture的属性改为true
    //     this.$refs.videoRef1['playsinline'] = true; //disablePictureInPicture的属性改为true
    //
    //     this.$refs.videoRef2['playsinline'] = true;
    //
    //     this.$refs.videoRef3['playsinline'] = true;
    //
    //     this.$refs.videoRef4['playsinline'] = true;
    //
    //
    // }
    this.forum_tabs_height = 1160;
    // console.log(this.forum_tabs_height,'123123');
    // this.refs.video.controlsList = "nodownload";
    // document.getElementsByClassName('video-class').controlsList = "nodownload" ;
  },
  computed: {
    ...mapGetters(["token", "userInfo"]),
  },
  watch: {
    activeName: function(val) {
      this.page = 1;
      if (val == "1") {
        this.loading = true;
        this.liveList = [];
        this.numberPage = 9;
        if (this.showForumTabsTable == "1") {
          this.forumTabsTableType = 1;
        }
        this.getCountryStateApi();

        // this.getCompanySelectList();
      } else if (val == "2" || val == "3") {
        this.liveClassNumber = null;
        this.studio = null;
        this.companyName = null;
        this.locationName = null;
        this.numberPage = 9999;
        // this.page = 1;
      } else if (val == "4") {
        this.numberPage = 9;
        this.page = 1;

        this.getDetailLiveUser();
      } else if (val == "5") {
        if (this.showGuestsTabsTable == "1") {
          this.guestsTabsTableType = "1";
        }
        this.guestsCompanyName = "";
        this.guestsBusiness = "";
        this.guestsLocation = "";
        this.numberPage = 9;
        this.page = 1;
        // this.getDetailLiveUserJoinList();

        this.getCountryStateApi();
      } else {
        this.numberPage = 9;
      }
      if (val != "3" && val != "1") {
        this.loading = true;
        this.liveList = [];
        //this.getExhList();
        // this.getCompanySelectList();
        this.numberPage = 9;
      }
    },
    // liveClassNumber() {
    //   if (this.abcString == "") {
    //     this.search();
    //   }
    // },
  },
};
</script>

<style>
  .el-message-box__wrapper{
    z-index: 20004!important;
  }
</style>
<style scoped>
.company-top-logo{
  margin: 30px auto -40px;
  border-radius: 50%; height: 98px; width: 98px; overflow: hidden;
  background: rgb(255, 255, 255);
  position: absolute;
  top: 5px;
  left: 46%;
  padding:0px;
  box-shadow: 0px 0px 12px 10px
    rgba(0, 113, 255, 0.1);
}
.new-code-btn-right {
  width: 35px;
  height: 35px;
  display: block;
  position: absolute;
  right: 65px;
  bottom: -65px;
}

.new-code-btn-right img {
  width: 25px;
  height: 25px;
}
.form_index_top_div {
  width: 100%;
  min-width: 1200px;
  /*height: 22.5vw;*/
  min-height: 350px;
  object-fit: cover;
  margin-top: -81px;
}
.form_index_top_div img {
  margin-top: 0px;
  width: 100%;
  height: 100%;
}

.form-content-wrap {
  position: relative;

  background-color: #0b8afd;
}

.form-content-wrap >>> .forum_tabs .el-tabs__item {
  font-size: 18px;
  color: #4c4c4c !important;
  padding:0 15px 10px;
  border-right: 1px solid #e5e5e5;
}
.form-content-wrap >>> .forum_tabs .el-tabs__item:last-child{
  border:none;
}
.form-content-wrap >>> .el-tabs__nav-wrap {
  padding-left: 30px;
}
.form-content-wrap >>> .el-tabs__nav-wrap::after {
  background: none !important;
}
.form-content-wrap >>> .forum_tabs .el-tabs__item.is-active {
  color: #0071fd !important;
  font-weight: bold;
}
.form-content-wrap >>> .el-tabs__item {
  height: 50px !important;
  line-height: 40px;
}
.description {
  margin-top: 30px;
  background-color: #FFFFFF;
  border-radius: 10px;
  margin-bottom: 40px;
  padding-top: 20px;
}
.description-wrap {
  margin: 40px 0;
  padding: 20px 40px;
}
.bg-wrap {
  width: 100%;
  min-width: 1200px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
  z-index: 0;
  background-color: #0b8afd;
}
.bg-wrap div:nth-child(2n-1) {
  width: 100%;
  height: 400px;
  /*background: url("../../assets/index-bg-1.jpg");*/
  background-color: #f2f7ff;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bg-wrap div:nth-child(2n) {
  width: 100%;
  height: 400px;
  /*background: url("../../assets/index-bg-2.jpg");*/
  background-color: #f2f7ff;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bg-wrap div:first-child {
  /*background: #0c6dce !important;*/
  background-color: #f2f7ff;
  /* background-size: 100% 100%;
  background-repeat: no-repeat; */
}
.bg-wrap div:last-child {
  /*background: #0c6dce !important;*/
  background-color: #f2f7ff;
  /* background-size: 100% 100%;
  background-repeat: no-repeat; */
}
.form-content {
}

.forum >>> .el-dialog__headerbtn .el-dialog__close {
  width: 20px !important;
  height: 20px !important;
  color: #fff !important;
  background: #0c6dce !important;
  /* padding: 1px !important; */
  border-radius: 50% !important;
  line-height: 20px !important;
}
.forum >>> .el-dialog {
  background: rgb(242, 242, 242);
}
.dislogCon-Participants >>> .el-dialog__headerbtn .el-dialog__close {
  width: 20px !important;
  height: 20px !important;
  color: #fff !important;
  background: #0c6dce !important;
  /* padding: 1px !important; */
  border-radius: 50% !important;
  line-height: 20px !important;
}

.dislogCon-Participants >>> .el-dialog__body {
  margin-top: 20px;
  padding: 40px 50px !important;
}
.dislogCon-Participants >>> .el-button--primary {
  background: linear-gradient(0deg, rgb(0, 180, 251), rgb(0, 104, 234));
  background: none !important;
  border: 1px solid #fff !important;
}
.showed {
  top: 0;
}
.hiddened {
  position: fixed;
  top: -245px;
}

.box {
  width: 100%;
  min-width: 1200px;
  min-height: 510px;
  background: #f2f2f2;
}

.box_content-video {
  width: 1200px;
  margin: auto;
  padding: 10px 0 10px 0;
  position: relative;
}
.box_content {
  width: 1200px;
  margin: auto;
  min-height: 120px;
  padding: 0px 20px;
  position: relative;
  background: #FFFFFF;
  padding-bottom: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 12px 1px
              rgba(0, 113, 255, 0.1);
}
.box_content-color >>> p {
  color: #4d4d4d !important;
}
.box_content-color >>> p strong {
  color: #4d4d4d !important;
}
.box_content-color >>> span {
  /*color: #4d4d4d ;*/
  background: none !important;
}
.box_content-color >>> a {
  color: #4d4d4d !important;
}
.main_title_right_top_no {
  position: absolute;
  right: 40px;
  /* top: 7.5% !important; */
  top: 5px;
}

.main_title_right_top {
  position: absolute;
  right: 40px;
  /* top: 7.5% !important; */
  /* top: 315px; */
  /* top: 72%; */
}
.main_title_right_top_en {
  position: absolute;
  right: 40px;
  /* top: 8.4%; */
  /* top: 315px; */
  /* top: 61%; */
}

.main_title_right_top_no .el-button {
  display: block;
  padding: 0px 20px !important;
}
.main_title_right_top .el-button {
  display: block;
  padding: 0px 20px !important;
}
.main_title_right_top_en .el-button {
  display: block;
  padding: 0px 20px !important;
}

.main_title {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-top: 25px;
}
.apply-btn .main_title {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-top: 0;
}

.main_title_left {
  font-family: MicrosoftYaHei-Bold;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 17px;
  letter-spacing: 0;
  color: #0f408a;
}

.time {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 17px;
  letter-spacing: 0;
  color: #424242;
  margin-top: 20px;
}

.introduction {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 28px;
  letter-spacing: 0;
  color: #a1a1a1;
  text-indent: 2em;
  margin-top: 20px;
}

.pagination {
  margin: auto;
  margin-top: 30px;
  text-align: center;
}
.pagination .el-pagination__jump{
}

.video_info {
  margin-top: 20px;
  margin-bottom: 40px;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  margin-left: 20px;
}
.video_info:first-child{
  margin-left: 0px;
}
.video {
  width: 281px;
  height: 176px;
  /* background-color: #000000; */
  border-radius: 5px;
  border: 2px solid #00deff;
  /* flex: 1; */
}
.video video {
  object-fit: fill;
  border-radius: 5px;
  width: 100%;
  height: 100%;
}
.forum_tabs {
  margin-top: 20px;
}
.form-content-title {
  margin: 20px 0;
}
.form-content-title span {
  border-left: 2px solid #fb9129;
  color: #fff;
  font-size: 18px;
  padding-left: 20px;
}
.form-content-detail-title {
  margin: 20px 0;
}
.form-content-detail-title span {
  border-left: 4px solid #fb9129;
  color: #000;
  font-size: 22px;
  padding-left: 20px;
}

.search_live {
  margin-top: 20px;
  background: #FFFFFF;
  border-radius: 10px;
  height: 50px;
  padding-left: 10px;
  padding-top: 8px;
  /*padding-bottom: 30px;*/
  margin-bottom: 20px;
}

.el-button {
  padding: 0px 20px !important;
}

.el-button--primary {
  background: linear-gradient(0deg, rgb(0, 180, 251), rgb(0, 104, 234));
}

.el-button--warning {
  background-color: #f4a100 !important;
  border: none !important;
}

/*报名button固定在页面*/
.apply-wrap {
  width: 100%;
  height: 64px;
  background: #fff;
  box-shadow: 2px 2px 3px #ddd;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 5;
}
.apply-btn {
  width: 1156px;
  height: 40px;
  margin: auto;
  padding: 12px 22px;
}
.beyond-hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 40px;
  width: 80%;
}
.dislogCon {
  text-align: center;
}
.img-formBtn {
  /* margin: 0 auto; */
  text-align: right;
  margin-top: 20px;
  /* margin-right: 20px; */
}
.img-down-formBtn {
  background: #ff9e00;
  width: 100px;
  height: 40px;
  color: #ffffff;
  border: none;
  font-size: 18px;
}
.img-camcale-formBtn {
  background: #cccccc !important;
  border: 1px solid #cccccc !important;
  width: 100px;
  height: 40px;
  color: #ffffff;
  border: none;
  font-size: 18px;
}
.orderby-view-active {
  /* background: #0f408a !important; */
  color: #0f408a !important;
}
.choose-abc-active {
  /* color: #0f408a !important; */
  color: #0071fe !important;
  /*background: #ed7a2f;*/
}

.dialog-top {
  text-align: center;
  padding: 20px 25px;
  /*background: linear-gradient(to bottom right, #005be7 30%, #00c4ff 100%) 100%*/
  background: url("../../assets/img/01.png") no-repeat;
  background-size: 100% 100%;
}
.broadCastList-company {
  font-size: 14px;
  color: #fff;
  font-weight: bold;
}

.choose_active {
  /* background: #0f408a; */
  color: #ed7a2f;
}

.forum_tabs_table {
  height: 42px;
  margin-top: 20px;
  overflow: hidden;
  color: #000;
  position: relative;
  z-index: 1;
  /* overflow: auto; */
}
.forum_tabs_table_btn {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 9;
}
.forum_tabs_table_btn div {
  float: left;
  padding: 10px 60px;
  cursor: pointer;
}
.forum_tabs_table_active {
  padding: 11px 60px !important;
  background: #0f408a !important;
  color: #fff !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.forum_tabs_table_left {
  color: #fff;
}
.forum_tabs_table_right {
  color: #fff;
}
.forum_tabs_table_left_active {
  padding: 11px 60px !important;
  background: #0f408a !important;
  color: #fff !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.forum_tabs_table_bg {
  width: 100%;
  height: 39px;
  /* background: #eeeeee; */
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 0;
  /* border-bottom: 1px solid #ccc; */
  border-bottom: 1px solid #0f408a;
}

.guests_tabs_table {
  height: 42px;
  margin-top: 20px;
  overflow: hidden;
  color: #000;
  position: relative;
  /* overflow: auto; */
}
.guests_tabs_table_btn {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 9;
}
.guests_tabs_table_btn div {
  float: left;
  padding: 10px 60px;
  cursor: pointer;
}
.guests_tabs_table_active {
  padding: 11px 60px !important;
  background: #0f408a !important;
  color: #fff !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.guests_tabs_table_left {
  color: #fff;
}
.guests_tabs_table_conter {
  color: #fff;
}
.guests_tabs_table_right {
  color: #fff;
}
.guests_tabs_table_left_active {
  padding: 11px 60px !important;
  background: #0f408a !important;
  color: #fff !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.guests_tabs_table_bg {
  width: 100%;
  height: 39px;
  /* background: #eeeeee; */
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 0;
  /* border-bottom: 1px solid #ccc; */
  border-bottom: 1px solid #0f408a;
}

.entrance-right-wrap {
  width: 160px;
  position: fixed;
  left: 85%;
  top: 20%;
  z-index: 10;
  text-align: center;
}
.entrance-right-top {
  text-align: center;
  padding: 10px 20px;
  color: #fff;
  background: linear-gradient(0deg, rgb(236, 141, 55), rgb(239, 106, 40));
}
.entrance-right-content {
  background: #fff;
}
.entrance-right-content div {
  border-bottom: 1px solid #000;
  padding: 15px;
  cursor: pointer;
}

.entrance-right-content div a {
  color: #000;
}
.entrance-right-bottom {
  text-align: center;
  padding: 10px 20px;
  color: #fff;
  background: linear-gradient(0deg, rgb(0, 180, 251), rgb(0, 104, 234));
  margin-bottom: 20px;
}
.entrance-right-qrcode {
  background: #fff;
  color: rgb(0, 104, 234);
  text-align: center;
  padding-bottom: 20px;
}
.entrance-right-qrcode p {
  padding-top: 10px;
  font-size: 16px;
}
</style>
<style>
.forum_tabs .el-tabs__item {
  color: #a1a1a1 !important;
}

.forum_tabs .el-input-group__append,
.el-input-group__prepend {
  border-radius: 0;
  background-color: #0f408a;
  border: #0f408a;
}
.forum_tabs .el-tabs__item:hover {
  color: #424242 !important;
  cursor: pointer !important;
}

.forum_tabs .el-tabs__item.is-active {
  color: #424242 !important;
}

.forum_tabs .el-tabs__active-bar {
  background-color: #f57803;
  height: 4px;
}

.search_live .el-form-item {
  margin-right: 0 !important;
}

.search_live .el-input__inner {
  background-color: #eff0f1;
  border: none;
}

.search_live .el-input__inner ::-webkit-input-placeholder {
  color: #036ffc;
}

.search_live .el-select .el-input__inner:focus {
  border-color: #dcdfe6 !important;
}

.search_live .el-input__inner:focus {
  border-color: #dcdfe6 !important;
}

.forum_tabs .el-tabs__header {
  margin: 0 !important;
}

/*  4视频修改 */
.videoBox {
  /*width: 300px;*/
  /*height: 150px;*/
  /*position: absolute;*/
  /*top:100px;*/
  /*left:40px;*/
  -webkit-transform: rotateZ(0deg);
}
.videoBox .player {
  position: absolute;
  width: 100%;
  height: 400px;
  top: 0px;
  left: 0px;
  z-index: 3;
}

.videoBox .poster {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
}

.videoBox .playIcon {
  /*width: 23%;*/
  opacity: 0.8;
  position: absolute;
  z-index: 2;
  position: absolute;
  height: 40%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.search-span {
  text-align: center;
  color: #fff;
  font-size: 16px;
}
.img-wrap {
  width: 100%;
  padding: 20px 0;
  display: flex;
}
.img-wrap-left {
  flex: 1;
  padding: 20px;
  border-radius: 20px;
  min-height: 500px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ececec;
}
.choose-img {
  width: 300px;
  text-align: center;
  margin: 0 auto;
}
.img-wrap-right {
  flex: 2.5;
  margin: 0 auto;
  padding-top: 20px;
}
.img-wrap-right-top {
  display: inline-block;
  margin-top: 20px;
}
.img-wrap-right-top img {
  width: 150px;
}
.img-wrap-right-top-div {
  /* display: inline-block; */
  float: left;
  height: 290px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 3px solid #ececec;
  margin: 0 10px;
  position: relative;
}
/* .img-right{
        display: none;
    } */
.img-right {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 0 !important;
  width: 30px !important;
  height: 30px;
}
.img-wrap-right-top-div img {
  padding: 20px 10px;
}
.img-wrap-right-top-div-active {
  border: 3px solid #ff9e00;
}
.img-wrap-title {
  width: 150px;
  margin: 0 auto;
  position: relative;
  z-index: 9;
}
.img-wrap-title p {
  color: #212c67;
  font-size: 1.3rem;
  z-index: 9;
}
.div-border-bottom-color {
  width: 150px;
  height: 3px;
  background: #c7d0f2;
  position: absolute;
  left: 0;
  bottom: 1px;
  z-index: -1;
}
.pc-url-div {
  margin: 60px auto 50px;
  /* width: 500px; */
  height: 80px;
  line-height: 80px;
  border-radius: 10px;
  background: #ececec;
  color: #000;
  display: inline-flex;
  align-content: center;
  justify-content: center;
  padding: 0 50px;
  /* margin: 0 auto; */
}

.url-formBtn {
  margin: 0 auto;
  text-align: center;
  /* margin-top: 30px;
        margin-right: 20px; */
}
.pc-url-formBtn {
  background: #ff9e00;
  width: 100px;
  height: 40px;
  color: #ffffff;
  border: none;
  font-size: 18px;
}

.inside-adlocation-box{
  margin-top:30px;
  margin-bottom:30px;
}

.inside-adlocation-box a{
  height:170px;
  width:100%;
  display:block;
}

.inside-adlocation{
  width:100%;
  height:170px;
}

.inside-adlocation img{
  width:100%;
  height:100%;
  border-radius:10px;
}

.ad-logo-exhibitors{
 display:flex;
 justify-content:space-between;
 align-items:center;
 margin-bottom:10px;
}

.ad-logo-exhibitors-title{
  font-size:18px;
  color:#fff;
  padding-bottom:20px;
}
.ad-logo-exhibitorsitems{
  width:200px;
  height:160px;
  flex:1;
  margin-right:25px;
  border-radius:10px;
  background:#fff;
}

.ad-logo-exhibitorsitems div{
  width:100%;
  height:100%;
  cursor:pointer;
}
.ad-logo-exhibitorsitems div img{
   width:100%;
  height:100%;
  border-radius:10px;
}

.ad-logo-exhibitorsitems:last-child{
  margin-right:0;
}

.el-message-box{
  border-radius: 10px;
  padding-bottom: 20px;
  width: 320px;
}
.el-message-box .el-message-box__headerbtn{
  border-radius: 50%;
  width: 20px;
  height: 20px;
  background-color: #0071ff;
}
.el-message-box .el-message-box__headerbtn .el-icon-close{
  color: #ffffff;
}
.el-message-box .el-button{
  font-size: 14px;
  background-color: #E5E5E5;
  color: #666666;
  border: 1px solid #E5E5E5;
  padding-left: 30px;
  padding-right: 30px;
  border-radius: 4px;
  margin-right: 20px!important;
}
.el-message-box .el-button--primary{
  background-color: #0071ff;
  color: #ffffff;
  border: 1px solid #0071ff;
  position: relative;
  top: 1px;
  margin-left: 10px !important;
  margin-right: 0px!important;
  height: 34px !important;
  line-height: 34px !important;
}
.el-message-box .el-message-box__btns{
  text-align: center;
  margin-top: 20px;
}
.el-message-box  .el-message-box__content{
  padding-top: 30px;
  padding-bottom: 30px;
  letter-spacing: 1px;
  text-align: center;
}
</style>
